export default {
  methods: {
    convertValueToName(value) {
      //links in sidebar have values and names keys - some of the values have more than 1 word
      // for that we need to split the value to the right name to active all the selected classes for the ui
      if (value == 'knowledgeBase') return 'Knowledge base'
      if (value == 'uploadQuestions') return 'Upload questions'
      else {
        return value
      }
    },
  },
}
